import { communicateApi } from 'services/http';
import { uiShowPreLoader, uiHidePreLoader, } from 'src/store/ui-reducer';
import { ROLES } from 'services/constants';

import { loadAppointsByDocIdAndDate } from '../../services/commonRequests';
import * as createNewJobTypes from './createNewJobActionTypes';

// Services
import { alertError } from 'services/alerts';


export const clearNewJob = () => ({
  type: createNewJobTypes.CLEAR_NEW_JOB_DATA
});

export const setInfo = (infoObj) => ({
  type: createNewJobTypes.NEW_JOB_SET_INFO,
  payload: infoObj
});

export const updateFilters = (updateObj) => ({
  type: createNewJobTypes.NEW_JOB_UPDATE_FILTERS,
  payload: updateObj
});

//──── Appointments ──────────────────────────────────────────────────────────────────────
const setAppointmentsList = (list) => ({
  type: createNewJobTypes.NEW_JOB_SET_APPOINTMENTS,
  payload: list,
});

export const loadAppointmentsByDoctorIdAndDate = (doctorId, date) => (dispatch, getStore) => {
  const store = getStore();
  const { auth, } = store;
  if (auth && auth.isAuthenticated &&
    (auth.role === ROLES.STAFF || auth.role === ROLES.PRACTITIONER || auth.role === ROLES.RADIOLOGY)
  ) {
    dispatch(uiShowPreLoader());
    loadAppointsByDocIdAndDate(doctorId, date)
      .then(list => {
        dispatch(uiHidePreLoader());
        dispatch(setAppointmentsList(list));
      })
      .catch(() => {
        dispatch(uiHidePreLoader());
      });
  }
};

//──── Details ───────────────────────────────────────────────────────────────────────────
export const setDetails = (detailsObj) => ({
  type: createNewJobTypes.NEW_JOB_SET_DETAILS,
  payload: detailsObj,
});


//──── Communication with user ───────────────────────────────────────────────────────────────
// SMS
export const createJob = (url, data) => dispatch => {
  dispatch(uiShowPreLoader());
  return communicateApi
    .post(url, data)
    .then(() => {
      dispatch(uiHidePreLoader());
      return true;
    })
    .catch(err => {
      const { response } = err;
      if ((response && response.status !== 401) || !response) {
        alertError(err.message);
      }
      dispatch(uiHidePreLoader());
      throw new Error(err);
    });
};